// extracted by mini-css-extract-plugin
export default {"clockButton":"Planning_clockButton__0kGnq","clocking":"Planning_clocking__X1Djk","not-clocking":"Planning_not-clocking__HmpZl"};